export default "__VITE_ASSET__BXCL6PEK__"